import { MiddlewareAPI } from "redux";
import { IUserState } from "../../redux/types/IUserState";

const ENVIRONMENT_DEVELOPMENT = "development";
const ENVIRONMENT_PRODUCTION = "production";

let cachedStore: MiddlewareAPI;
export const attachReduxStore = (store: MiddlewareAPI) => (cachedStore = store);

declare let switches: { environment?: string };

const getWebpackEnvironment = (): string => switches.environment;
const getBackendEnvironment = (): string => {
    if (cachedStore) {
        const user: IUserState = cachedStore.getState().user;
        return user.environment;
    }
};

export const isDebug = (): boolean =>
    getWebpackEnvironment() === ENVIRONMENT_DEVELOPMENT;

const matchBackendEnvironment = (environment: string): boolean =>
    getBackendEnvironment() === environment;

const matchDevelopment = isDebug;

const matchNonProduction = (): boolean =>
    isDebug() || !matchBackendEnvironment(ENVIRONMENT_PRODUCTION);

const matchNone = (): boolean => false;
const matchAny = (): boolean => true;

export const AGENT_SHOW_AGENT_TAB = matchDevelopment;
export const AGENT_SHOW_FEEDBACK = matchNonProduction;
export const AGENT_SHOW_REASONING_SUMMARY = matchDevelopment;
export const AGENT_USE_STREAMING_WEBSOCKET = matchAny;
export const ALERTS_USE_TOASTS = matchAny;
export const BILLING_SHOW_LICENSES = matchDevelopment;
export const LOG_TO_CONSOLE = matchDevelopment;
export const LOG_ESTIMATION_TO_CONSOLE = matchNonProduction;
export const I18N_DEBUG_MODE = matchNone;
export const I18N_STORE_KEYS_TO_VARIABLE = matchDevelopment;
export const GHS_SHOW_CODES = matchAny;
export const GRAPH_SHOW_MISSING_DATA_WARNINGS = matchDevelopment;
export const GRAPH_USE_PATTERNS = matchDevelopment;
export const IMAGES_SHOW_RENDERER_SELECTOR = matchDevelopment;
export const IMAGES_USE_SVG_RENDERING = matchAny;
export const OPTIONS_SHOW_OPTIONS = matchNonProduction;
export const OPTIONS_SHOW_WEIGHTS = matchNonProduction;
export const NOTEBOOK_SHOW_NOTEBOOK_APP = matchNonProduction;
export const PREDICTOR_SHOW_CHEMPREDICTOR = matchNonProduction;
export const PREDICTOR_USE_WEBSOCKETS = matchAny;
export const PROPERTIES_DATA_ESTIMATION = matchAny;
export const PROPERTIES_DATA_ESTIMATION_INLINE = matchNone;
export const PROPERTIES_DISPATCH_ESTIMATION = matchNone;
export const PROPERTIES_DISPATCH_ESTIMATION_USE_CACHE = matchNonProduction;
export const PROPERTIES_ESTIMATION_SHOW_ALERT_ERRORS = matchDevelopment;
export const PROPERTIES_HIGHLIGHT_EXPERIMENTAL_COLOR = matchAny;
export const PROPERTIES_HIDE_EMPTY_ROWS = matchAny;
export const PROPERTIES_USE_COMPARISON_WORKSPACE = matchNone;
export const PROPERTIES_SHOW_AGENT = matchNonProduction;
export const PROPERTIES_SHOW_ESTIMATED_IF_EXPERIMENTAL = matchAny;
export const PROPERTIES_SHOW_CATEGORIES = matchAny;
export const PROPERTIES_SHOW_FEEDBACK = matchAny;
export const PROPERTIES_SHOW_NONLOG_PROPERTIES = matchDevelopment;
export const PROPERTIES_SHOW_SUBPROPERTIES = matchAny;
export const PROPERTIES_SHOW_SUBPROPERTIES_RANK = matchDevelopment;
export const PROPERTIES_SHOW_NMR_PREDICTION = matchNonProduction;
export const PROPERTIES_SHOW_METABOLITE_PREDICTION = matchAny;
export const PROPERTIES_SCORE_WEIGHTS_USE_DROPDOWNS = matchAny;
export const SDS_SHOW_SDS = matchAny;
export const SDS_SHOW_FIND_BY_CHEMICAL_TAB = matchDevelopment;
export const SDS_ENABLE_SAVE_LOAD = matchDevelopment;
export const SDS_ENABLE_BACKEND_PDF_PRINTING = matchDevelopment;
export const SDS_ENABLE_ADDITIONAL_JURISDICTIONS = matchDevelopment;
export const SDS_SHOW_MIXTURE_ALGORITHM_DROPDOWN = matchDevelopment;
export const SDS_APPLY_PRINT_STYLES = matchNone;
export const SDS_USE_REALTIME_BUILD = matchAny;
export const REACTIONS_SHOW_REACTION_ANALYZER = matchAny;
export const REACTIONS_SHOW_REACTION_COMPONENT_PREDICTION = matchNonProduction;
export const REACTIONS_ENABLE_REACTION_COMPONENT_PREDICTION = matchDevelopment;
export const REACTIONS_USE_UNIFIED_ANALYSIS = matchAny;
export const REACTIONS_SHOW_ANALYSIS_RAW_EXTRAS = matchNone;
export const REACTIONS_SHOW_ANALYSIS_RISK_PERCENTAGES = matchNone;
export const REACTIONS_SHOW_ANALYSIS_ALERT_DETAILS = matchNone;
export const REACTIONS_SHOW_TOXICITY_SCORE = matchNone;
export const REACTIONS_SHOW_PROCESS_CONDITIONS = matchNone;
export const REACTIONS_USE_REALTIME_ANALYSIS = matchAny;
export const REACTIONS_SHOW_COMPARE_TAB = matchAny;
export const REACTIONS_SHOW_INTERMEDIATE_PATH_COMPARE = matchAny;
export const REACTIONS_SHOW_ROUTE_COMPARISON_CHARTS = matchNone;
export const REACTIONS_USE_SHARED_LIBRARY = matchAny;
export const REACTIONS_SHOW_LIBRARY_FLOATING_BUTTON = matchAny;
export const REACTIONS_SHOW_BUILD_BUTTON = matchAny;
export const LIBRARY_SHOW_VIRIDISCHEM_ID = matchDevelopment;
export const LIBRARY_SHOW_STAGE_TAB = matchDevelopment;
export const LIBRARY_GROUP_REACTION_CHEMICAL_TYPES = matchNone;
export const SEARCH_RESULTS_SHOW_RELEVANCE = matchDevelopment;
export const SEARCH_RESULTS_ALWAYS_SHOW_SELECTOR = matchNone;
export const SEARCH_ADVANCED_SHOW_FUNCTIONAL_USE = matchAny;
export const SEARCH_ADVANCED_SHOW_DRUG_IMPURITY = matchAny;
export const SEARCH_ADVANCED_SHOW_STRUCTURE = matchAny;
export const STRUCTURE_DRAW_USE_SMILES_TEXT_INPUT = matchDevelopment;
export const STRUCTURE_DRAW_USE_KETCHER = matchNonProduction;
export const STRUCTURE_DRAW_SHOW_SIMILARITY_SUBSTRUCTURE = matchAny;
export const VIRIDISCHEM_ADMIN_SHOW_ADMIN_TAB = matchAny;
